/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { NgModule } from '@angular/core';

import { config } from './application.config';

// You can modify or replace module config here

@NgModule(config)
export class ApplicationModule {}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/application.module.ts